/**
 * DevExtreme (esm/__internal/grids/new/card_view/header_panel/a11y/const.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const I18N_KEYS = {
    common: "dxCardView-ariaHeaderItemLabel",
    headerFilter: "dxCardView-ariaHeaderHasHeaderFilterLabel",
    sortingAsc: "dxCardView-ariaHeaderItemSortingAscendingLabel",
    sortingDesc: "dxCardView-ariaHeaderItemSortingDescendingLabel",
    sortIndex: "dxCardView-ariaHeaderItemSortingIndexLabel"
};
export const I18N_MESSAGE_SEPARATOR = ", ";
